import * as toast from '@zag-js/toast'

export type ToastCardType = 'success' | 'error' | 'info' | 'warning'

const cardTypeToToastType: Partial<Record<ToastCardType, toast.Type>> = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'custom',
}

export const toastTypeToCardType: Partial<Record<toast.Type, ToastCardType>> = {
  success: 'success',
  error: 'error',
  info: 'info',
  custom: 'warning',
}

export const toaster = toast.createStore({
  placement: 'bottom-start',
  gap: 32,
})

export function useToast() {
  function createToast(options: {
    title: string
    type: ToastCardType
    description: string
    duration?: number
  }) {
    const { type: cardType } = options

    const toastParams = {
      ...options,
      type: cardTypeToToastType[cardType],
    }

    toaster.create(toastParams)
  }

  return { createToast }
}
